import { downloadOptions } from "@/mocks/home";

export default function DownloadSection() {
  return (
    <section id="download" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-widest text-primary-700">DOWNLOADS</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            三种下载方式，按设备对号入座
          </h2>
          <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
            不确定该下哪个版本？先看下方的版本号与大小，再选择与你设备系统匹配的那一项即可。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {downloadOptions.map((option) => (
            <article
              key={option.key}
              className={`flex flex-col rounded-lg border bg-background-50 p-5 md:p-6 ${
                option.featured ? "border-primary-300" : "border-background-200"
              }`}
            >
              <div className="flex items-start justify-between gap-3">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${
                    option.featured ? "bg-primary-600 text-background-50" : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  <i className={option.icon}></i>
                </span>
                {option.featured && (
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-label whitespace-nowrap">
                    推荐
                  </span>
                )}
              </div>

              <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">{option.name}</h3>
              <p className="mt-1 text-xs text-foreground-500">{option.platform}</p>
              <p className="mt-3 text-sm leading-6 text-foreground-600">{option.desc}</p>

              <dl className="mt-4 grid grid-cols-3 gap-2 rounded-md bg-background-100 px-3 py-3">
                <div>
                  <dt className="text-[11px] text-foreground-500">版本</dt>
                  <dd className="font-label text-sm text-foreground-950">{option.version}</dd>
                </div>
                <div>
                  <dt className="text-[11px] text-foreground-500">大小</dt>
                  <dd className="font-label text-sm text-foreground-950">{option.size}</dd>
                </div>
                <div>
                  <dt className="text-[11px] text-foreground-500">更新</dt>
                  <dd className="font-label text-sm text-foreground-950">{option.updated.slice(5)}</dd>
                </div>
              </dl>

              <ul className="mt-4 space-y-2">
                {option.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line text-primary-600 mt-0.5"></i>
                    {point}
                  </li>
                ))}
              </ul>

              <a
                href="#guide"
                className={`mt-6 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  option.featured
                    ? "bg-primary-600 text-background-50 hover:bg-primary-700"
                    : "border border-background-300 text-foreground-900 hover:border-primary-400 hover:text-primary-700"
                }`}
              >
                <i className="ri-download-2-line"></i>
                获取{option.name}
              </a>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs text-foreground-500 leading-6">
          <i className="ri-information-line mt-0.5"></i>
          版本号与更新日期为示例展示，实际安装包请以官方页面发布的最新信息为准。
        </p>
      </div>
    </section>
  );
}